export default "__VITE_ASSET__BfOnLSQj__"